<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import TravelInsuranceData from '@/data/company-page-data/mapfre-sigorta/cross-pages/TravelInsurance'
export default {
  metaInfo: {
    title: 'Mapfre Sigorta Seyahat Sağlık Sigortası Fiyatları',
    meta: [
      {
        name: 'description',
        content: 'Yurt dışı ve yurt içi seyahatlerinizin keyfini çıkarmak için Mapfre Sigorta seyahat sağlık sigortanızı hemen satın alın, seyahat risklerini düşünmeyin.'
      }
    ]
  },
  name: 'MapfreSigortaTravelInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: TravelInsuranceData.headerContent,
      crossPageContent: TravelInsuranceData.crossPageContent,
      faqTitle: TravelInsuranceData.faqTitle,
      faqTitleDesc: TravelInsuranceData.faqTitleDesc,
      getPrice: TravelInsuranceData.getPrice
    }
  }
}
</script>
